export interface TSideBarState {
  page: { value: number; name: string; type: 'main' | 'list' | 'edit' };
}

enum ActionTypes {
  SET_SIDEBAR = '@@sidebar/SET_SIDEBAR',
}

export default ActionTypes;
